document.addEventListener('click', function (event) {
  const tab = event.target.closest('[data-os-sidebar-tab]');
  if (!tab) return;

  const mega = tab.closest('[data-os-sidebar-mega]');
  if (!mega) return;

  const targetId = tab.getAttribute('data-target');
  if (!targetId) return;

  mega.querySelectorAll('[data-os-sidebar-tab]').forEach((el) => {
    el.classList.remove('is-active');
  });

  mega.querySelectorAll('[data-os-sidebar-panel]').forEach((el) => {
    el.classList.remove('is-active');
  });

  tab.classList.add('is-active');

  const panel = mega.querySelector('#' + CSS.escape(targetId));
  if (panel) {
    panel.classList.add('is-active');
  }
});